"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieOptions = void 0;
class CookieOptions {
    constructor() {
        this.path = "/";
        this.secure = true;
        this.useRootDomain = true;
    }
}
exports.CookieOptions = CookieOptions;
